import React from 'react';
import { prettifyNumbers } from 'lib/dateUtilities';

function FollowCount({ following, followers }) {
    return (
          <p className="mt-2 text-base">
            <span className="text-gray-strongest font-bold">{prettifyNumbers(following)}</span>
            <span className="text-gray-mid ml-1">Following</span>
            <span className="text-gray-strongest font-bold ml-5">{prettifyNumbers(followers)}</span>
            <span className="text-gray-mid ml-1">Followers</span>
          </p>
    );
}

export default FollowCount;
